import { createContext } from 'react';
import { EntityGet } from 'data/firestore/types';
import { Widgetchatbot } from 'data/firestore/agent/widgetchatbot/types';

export interface Context {
    websiteChatbots?: EntityGet<Widgetchatbot>[];
}

const context = createContext<Context>({
    websiteChatbots: [],
});

export const { Provider, Consumer } = context;

export default context;
